import EpgConstants from './EpgConstants';
import { Dates } from '../../packages/dates'; 

class ScheduleList {

  constructor(nowTimeStamp) {
    this.list = [];
    this.totalColumnsWidth = 1120; //pixels
    this.columns = EpgConstants.TOTAL_TIMELINE_INTERVALS;
    this.minutesInColumn = EpgConstants.TIMELINE_CELL_SIZE_MS / (60 * 1000); //Minutes
    this.timeWindowLength = EpgConstants.TIMELINE_CELL_SIZE_MS * EpgConstants.TOTAL_TIMELINE_INTERVALS;
    //this.eventLeft;
    //this.eventRight;
    this.functionPaint;
    this.setInitiallist(new Dates().unix(nowTimeStamp));
  }

  setInitiallist(now) {

    const minutesStart = this.minutesInColumn * Math.floor(now.minute() / this.minutesInColumn)    
    const startTime = now.minute(minutesStart);
    let scheduled = new Dates(startTime);
    scheduled.second(0);
    scheduled.millisecond(0);    

    for (let i = 0; i <= this.columns -1; i++) {
      this.list.push(scheduled.unix());
      scheduled = scheduled.add(this.minutesInColumn, 'm'); 
    }

  }

  setPaintSchedule(functionPaint) {
    this.functionPaint = functionPaint;
  }
  
  setEventLeft(functionFocus) {
    this.eventLeft = functionFocus;
  }

  setEventRight(functionFocus) {
    this.eventRight = functionFocus;
  }

  move(startTime) {
    
    if (this.list && this.list.length && this.list.length > 0 && startTime) {      
      this.list = this.list.map((d, index) => new Dates().unix(startTime).add(index * this.minutesInColumn,'m')).unix();
      this.functionPaint(this.list, true); 
    }    
  }

  moveLeft(repeats = false) {
    if (this.list && this.list.length && this.list.length > 0) {
      const first = this.list[0];
      this.list.pop();
      this.list.unshift(new Dates().unix(first).add(this.minutesInColumn,'m').unix());
      this.functionPaint(this.list);
    }    
  }

  moveRight(repeats = false) {
    if (this.list && this.list.length && this.list.length > 0) {
      const last = this.list[this.list.length - 1];
      this.list.shift();
      this.list.push(new Dates().unix(last).add(this.minutesInColumn,'m').unix());
      this.functionPaint(this.list);
    }
  }

  movePageLeft(repeats = false) {
    if (this.list && this.list.length && this.list.length > 0) {
      const pageMinutes = this.minutesInColumn * this.columns;      
      this.list = this.list.map((d) => new Dates().unix(d).add(-1 * pageMinutes,'m').unix());
      this.functionPaint(this.list);    
    }
  }

  movePageRight(repeats = false) {
    if (this.list && this.list.length && this.list.length > 0) {
      const pageMinutes = this.minutesInColumn * this.columns;      
      this.list = this.list.map((d) => new Dates().unix(d).add(pageMinutes,'m').unix());
      this.functionPaint(this.list);
    }
  }

}

export default ScheduleList;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/ScheduleList.js